import FooterListItemPage from './FooterListItemPage'
import FooterListItemUrl from './FooterListItemUrl'
import FooterListItemSocial from './FooterListItemSocial'

const FooterListItem = props => {
    const { layout, type } = props

    if (layout === 'link') {
        if (type === 'page') return <FooterListItemPage {...props} />
        else if (['url', 'page-slug'].includes(type)) return <FooterListItemUrl {...props} />
    } else if (layout === 'social_link') return <FooterListItemSocial {...props} />
}

FooterListItem.propTypes = {
    layout: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
}

export default FooterListItem
